import { DiAndroid, DiAngularSimple, DiCss3, DiDocker, DiGoogleCloudPlatform, DiHtml5, DiJavascript, DiJoomla, DiNodejsSmall, DiPostgresql, DiReact, DiWordpress } from 'react-icons/di'
import { SiAmazons3, SiNestjs, SiRedis, SiSocketdotio, SiTypescript } from 'react-icons/si'

import './chip.scss'

export type chipType = 'react' | 'reactnative' | 'android' | 'node' | 'nestjs' | 'angular' | 'html' | 'scss' | 'css' | 'typescript' | 'joomla' | 'wordpress' | 'javascript' | 'googlecloud' | 'postgresql' | 'docker' | 'redis' | 'socketio' | 'awss3'

type ChipPorps = {
  type: chipType
}

const config = {
  react: { text: 'React', icon: <DiReact /> },
  reactnative: { text: 'React Native', icon: <DiReact /> },
  android: { text: 'Android', icon: <DiAndroid /> },
  node: { text: 'Node', icon: <DiNodejsSmall /> },
  nestjs: { text: 'NestJS', icon: <SiNestjs /> },
  angular: { text: 'Angular', icon: <DiAngularSimple /> },
  html: { text: 'HTML5', icon: <DiHtml5 />},
  css: { text: 'CSS', icon: <DiCss3 />},
  scss: { text: 'SCSS', icon: <DiCss3 />},
  typescript: { text: 'Typescript', icon: <SiTypescript />},
  joomla: { text: 'Joomla', icon: <DiJoomla />},
  wordpress: { text: 'Wordpress', icon: <DiWordpress />},
  javascript: { text: 'Javascript', icon: <DiJavascript />},
  googlecloud: { text: 'Google Cloud', icon: <DiGoogleCloudPlatform /> },
  postgresql: { text: 'PostgreSQL', icon: <DiPostgresql /> },
  docker: { text: 'Docker', icon: <DiDocker /> },
  redis: { text: 'Redis', icon: <SiRedis /> },
  socketio: { text: 'Socket.io', icon: <SiSocketdotio /> },
  awss3: { text: 'AWS S3', icon: <SiAmazons3 /> },
}

function Chip(props: Readonly<ChipPorps>) {
  return (
    <div className='comp-chip'>
      {config[props.type].icon}
      <div className='chip-text '>{config[props.type].text}</div>
    </div>
  )
}

export default Chip
